import { Tooltip, Typography } from "@mui/material";
import { formatDate, type DateFormat } from "../utils/format.ts";

interface FormattedDateProps {
  value: string | number | Date | null | undefined;
  format?: DateFormat;
  fallback?: string;
}

/** A date in the browser's locale, with the full date and time on hover. */
export default function FormattedDate({
  value,
  format = "date",
  fallback = "-",
}: FormattedDateProps) {
  const formatted = formatDate(value, format, "");
  if (!formatted) return <>{fallback}</>;

  return (
    <Tooltip title={formatDate(value, "full")}>
      <Typography component="span" variant="inherit">
        {formatted}
      </Typography>
    </Tooltip>
  );
}
